// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39IZp","colMin":"styles_colMin__t3DOm"};